export interface Topic {
  id: string
  nameKey: string
  descKey: string
  descLongKey: string
  iconName: string
  interestedCount: number
  keyQuestionKeys: string[]
}

export const TOPICS: Topic[] = [
  {
    id: 'ai-governance',
    nameKey: 'topic.aiGovernance.name',
    descKey: 'topic.aiGovernance.desc',
    descLongKey: 'topic.aiGovernance.descLong',
    iconName: 'Brain',
    interestedCount: 42,
    keyQuestionKeys: [
      'topic.aiGovernance.q1',
      'topic.aiGovernance.q2',
      'topic.aiGovernance.q3',
    ],
  },
  {
    id: 'climate-adaptation',
    nameKey: 'topic.climateAdaptation.name',
    descKey: 'topic.climateAdaptation.desc',
    descLongKey: 'topic.climateAdaptation.descLong',
    iconName: 'CloudRain',
    interestedCount: 38,
    keyQuestionKeys: [
      'topic.climateAdaptation.q1',
      'topic.climateAdaptation.q2',
      'topic.climateAdaptation.q3',
    ],
  },
  {
    id: 'food-security',
    nameKey: 'topic.foodSecurity.name',
    descKey: 'topic.foodSecurity.desc',
    descLongKey: 'topic.foodSecurity.descLong',
    iconName: 'Wheat',
    interestedCount: 29,
    keyQuestionKeys: [
      'topic.foodSecurity.q1',
      'topic.foodSecurity.q2',
      'topic.foodSecurity.q3',
    ],
  },
  {
    id: 'biodiversity',
    nameKey: 'topic.biodiversity.name',
    descKey: 'topic.biodiversity.desc',
    descLongKey: 'topic.biodiversity.descLong',
    iconName: 'Leaf',
    interestedCount: 24,
    keyQuestionKeys: [
      'topic.biodiversity.q1',
      'topic.biodiversity.q2',
      'topic.biodiversity.q3',
    ],
  },
  {
    id: 'innovative-finance',
    nameKey: 'topic.innovativeFinance.name',
    descKey: 'topic.innovativeFinance.desc',
    descLongKey: 'topic.innovativeFinance.descLong',
    iconName: 'Coins',
    interestedCount: 35,
    keyQuestionKeys: [
      'topic.innovativeFinance.q1',
      'topic.innovativeFinance.q2',
      'topic.innovativeFinance.q3',
    ],
  },
  {
    id: 'twin-transition',
    nameKey: 'topic.twinTransition.name',
    descKey: 'topic.twinTransition.desc',
    descLongKey: 'topic.twinTransition.descLong',
    iconName: 'Recycle',
    interestedCount: 31,
    keyQuestionKeys: [
      'topic.twinTransition.q1',
      'topic.twinTransition.q2',
      'topic.twinTransition.q3',
    ],
  },
  {
    id: 'frontier-tech',
    nameKey: 'topic.frontierTech.name',
    descKey: 'topic.frontierTech.desc',
    descLongKey: 'topic.frontierTech.descLong',
    iconName: 'Atom',
    interestedCount: 26,
    keyQuestionKeys: [
      'topic.frontierTech.q1',
      'topic.frontierTech.q2',
      'topic.frontierTech.q3',
    ],
  },
  {
    id: 'regenerative',
    nameKey: 'topic.regenerative.name',
    descKey: 'topic.regenerative.desc',
    descLongKey: 'topic.regenerative.descLong',
    iconName: 'Sprout',
    interestedCount: 22,
    keyQuestionKeys: [
      'topic.regenerative.q1',
      'topic.regenerative.q2',
      'topic.regenerative.q3',
    ],
  },
  {
    id: 'partnerships',
    nameKey: 'topic.partnerships.name',
    descKey: 'topic.partnerships.desc',
    descLongKey: 'topic.partnerships.descLong',
    iconName: 'Handshake',
    interestedCount: 19,
    keyQuestionKeys: [
      'topic.partnerships.q1',
      'topic.partnerships.q2',
      'topic.partnerships.q3',
    ],
  },
  {
    id: 'skills-mobility',
    nameKey: 'topic.skillsMobility.name',
    descKey: 'topic.skillsMobility.desc',
    descLongKey: 'topic.skillsMobility.descLong',
    iconName: 'GraduationCap',
    interestedCount: 17,
    keyQuestionKeys: [
      'topic.skillsMobility.q1',
      'topic.skillsMobility.q2',
      'topic.skillsMobility.q3',
    ],
  },
]
